export default __webpack_public_path__ + "static/media/Pin-InProgress.d4443298.svg";